module.exports = __webpack_public_path__ + "img/particle_motion_00087.7aead6f5.png";